<div class="container">
  <section class="section">
    <u-icon [model]="{ type: 'lottie-animation', value: LOTTIE_ANIMATION }"></u-icon>

    <h1>This Page isn't available</h1>
    <h3>It may have been moved or no longer exists.</h3>
    <u-button
      *featureFlagEnabled="DISABLED_HOME_WORKSPACE_FEATURE_FLAG"
      [versionNumber]="2"
      [label]="'Go to Homepage'"
      typeElement="primary"
      sizeElement="medium"
      (onClick)="navigateToHomepage()"
    ></u-button>
  </section>
</div>
